import { Injectable } from '@angular/core';
import { BaseNotifier } from '../../../../shared/notifiers/base-notifier';
import { Ref } from '../../../../shared/providers/ref';
import { FooterPanelState } from './footer-panel-state';

@Injectable()
export class FooterPanelNotifier extends BaseNotifier<FooterPanelState> {
  constructor(ref: Ref) {
    super(ref, { isOpen: false, label: '', panelHeight: 220, slots: [] });
  }

  toggle(): void {
    this.updateState(s => ({ ...s, isOpen: !s.isOpen }));
  }

  open(): void {
    this.updateState(s => ({ ...s, isOpen: true }));
  }

  close(): void {
    this.updateState(s => ({ ...s, isOpen: false }));
  }

  setHeight(height: number): void {
    this.updateState(s => ({ ...s, panelHeight: height }));
  }

  setContent(slots: FooterPanelState.Slot[], label: string): void {
    this.updateState(s => ({ ...s, slots, label }));
  }
}
